const state = {
  MbAudioActive: false,
  MbAudioConfig: {},
};

const mutations = {
  CHANGE_MBAUDIO_ACTIVE(state, a) {
    state.MbAudioActive = a;
  },
  CHANGE_MBAUDIO_CONFIG(state, a) {
    state.MbAudioConfig = a;
  },
};
const actions = {
  someAsyncTask({ commit }) {
    // do something async
    commit('TEST');
  },
};

const getters = {
  mbAudioActive: (state) => {
    return state.MbAudioActive;
  },
  mbAudioConfig: (state) => {
    return state.MbAudioConfig;
  },
};
export default {
  state,
  mutations,
  actions,
  getters,
};
